/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReactionDto } from './reactionDto';
import { NoteDto } from './noteDto';


export interface CreateAllergyRequestDto { 
    /**
     * Element identifier for the allergen
     */
    elementId: string;
    /**
     * Patient identifier
     */
    patientId: string;
    /**
     * Clinical status of the allergy
     */
    status: CreateAllergyRequestDto.StatusEnum;
    /**
     * Element identifier for verification status
     */
    verificationStatusElementId?: string;
    /**
     * Element identifier for criticality level
     */
    criticalityElementId?: string;
    /**
     * Reaction details
     */
    reactions?: Array<ReactionDto>;
    /**
     * Onset date/time of the allergy (ISO 8601)
     */
    onsetDateTime?: string;
    /**
     * Identifier of the person who recorded the allergy
     */
    recorder?: string;
    /**
     * Identifier of the person who asserted the allergy
     */
    asserter?: string;
    /**
     * Clinical notes about the allergy
     */
    note?: Array<NoteDto>;
    /**
     * Additional metadata for the allergy
     */
    metadata?: any;
}
export namespace CreateAllergyRequestDto {
    export type StatusEnum = 'active' | 'inactive' | 'resolved';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum,
        Resolved: 'resolved' as StatusEnum
    };
}


